<template>
  <div class="user-projects-context-select">
    <label class="sr-only" for="user-projects-context-select">
      {{ $t('UserProjects.context.label') }}
    </label>
    <Select
      id="user-projects-context-select"
      :model-value="selectedProjectId"
      :options="activeProjects"
      option-label="name"
      option-value="id"
      :placeholder="placeholder"
      :disabled="disabled"
      :loading="loading"
      append-to="body"
      class="user-projects-context-select__input"
      data-testid="user-projects-context-select"
      @update:model-value="onChange"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Select from 'primevue/select';

export default {
  name: 'UserProjectsContextSelect',
  components: {
    Select,
  },
  computed: {
    ...mapGetters('pmProject', {
      activeProjects: 'activeProjects',
      selectedProjectId: 'selectedProjectId',
      loading: 'loading',
      userProjectContextReady: 'userProjectContextReady',
    }),
    disabled() {
      return !this.userProjectContextReady || this.activeProjects.length === 0;
    },
    placeholder() {
      if (this.loading || !this.userProjectContextReady) {
        return this.$t('UserProjects.context.loading');
      }
      if (this.activeProjects.length === 0) {
        return this.$t('UserProjects.context.empty');
      }
      return this.$t('UserProjects.context.placeholder');
    },
  },
  methods: {
    ...mapActions('pmProject', ['changeUserProjectContext']),
    async onChange(projectId) {
      try {
        await this.changeUserProjectContext(projectId);
      } catch {
        // handled downstream
      }
    },
  },
};
</script>

<style scoped>
.user-projects-context-select {
  width: min(100%, 20rem);
}

.user-projects-context-select__input {
  width: 100%;
}
</style>
